export const postStatus: any = {
  draft: "Draft",
  publish: "Published",
  scheduled: "Scheduled",
};
